'use client';

import React from 'react';
import CosaServiceLayout from '@/components/CosaServiceLayout';

const serviceData = {
  slug: 'analyses-biomedicales',
  icon: 'fa-solid fa-flask',
  badge: 'Analyses Biomédicales',
  title: 'Analyses Biomédicales',
  subtitle: 'Analyses de haute précision en partenariat avec le Labo Dr. Pierre Montagnier',
  heroImage: '/assets/images/service_biomedical_analysis.png',
  heroAlt: 'Technicien de laboratoire africain effectuant une analyse biomédicale à COSA',
  accentColor: '#0e5932',
  description: `Les analyses biomédicales de COSA, en partenariat avec le Labo Dr. Pierre MONTAGNIER, offrent des analyses de haute précision et une collecte d'echantillons professionnelle. Nos services couvrent tous les types d'analyses médicales essentielles.`,
  features: [
    { icon: 'fa-solid fa-droplet', title: 'Analyses Sanguines', description: 'Analyses complètes du sang incluant hémogramme, biochimie et sérologie.' },
    { icon: 'fa-solid fa-microscope', title: 'Analyses Microbiologiques', description: 'Cultures, antibiogrammes et identification de micro-organismes.' },
    { icon: 'fa-solid fa-vial', title: 'Analyses d\'Urine', description: 'Analyses urinaires complètes pour diagnostic et suivi.' },
    { icon: 'fa-solid fa-flask-vial', title: 'Analyses Spécialisées', description: 'Analyses hormonales, immunologiques et toxicologiques.' },
    { icon: 'fa-solid fa-house-medical', title: 'Collecte à Domicile', description: 'Service de collecte d\'echantillons directement à votre domicile.' },
    { icon: 'fa-solid fa-bolt', title: 'Résultats Rapides', description: 'Résultats disponibles en 24-48h avec interprétation médicale.' },
  ],
  process: [
    { step: '01', title: 'Prescription Médicale', description: 'Obtenez une prescription de votre médecin.' },
    { step: '02', title: 'Prise de Rendez-vous', description: 'Réservez un créneau pour la collecte d\'echantillons.' },
    { step: '03', title: 'Collecte d\'Echantillons', description: 'Collecte professionnelle et sécurisée de vos echantillons.' },
    { step: '04', title: 'Résultats & Interprétation', description: 'Recevez vos résultats avec interprétation médicale.' },
  ],
  stats: [
    { value: '50+', label: 'types d\'analyses' },
    { value: '99.8%', label: 'précision' },
    { value: '24-48h', label: 'délai de résultats' },
    { value: '1000+', label: 'analyses mensuelles' },
  ],
};

export default function AnalysesBiomedicalesPage() {
  return <CosaServiceLayout service={serviceData} />;
}
